import React from 'react';
import { Phone, MessageCircle, MapPin, Clock, Instagram, Mail } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 lg:py-32 bg-[#fffef2]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <p className="text-[#722F37] text-sm font-medium tracking-widest uppercase mb-4">
                Bize Ulaşın
              </p>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#333333] mb-6">
                İletişim
              </h2>
              <p className="text-[#666666] text-lg">
                Sipariş vermek veya soru sormak için bize ulaşabilirsiniz. 
                WhatsApp üzerinden hızlıca sipariş verebilirsiniz.
              </p>
            </div>

            {/* Contact Cards */}
            <div className="space-y-4">
              {/* Phone 1 */}
              <a
                href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
                className="flex items-center gap-4 p-6 bg-[#f6f5e8] hover:bg-[#722F37]/10 transition-colors group"
              >
                <div className="w-12 h-12 bg-[#722F37] flex items-center justify-center">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-[#666666]">Telefon 1</p>
                  <p className="text-lg font-semibold text-[#333333] group-hover:text-[#722F37]">
                    {restaurantInfo.phone1}
                  </p>
                </div>
              </a>

              {/* Phone 2 */}
              <a
                href={`tel:${restaurantInfo.phone2.replace(/\s/g, '')}`}
                className="flex items-center gap-4 p-6 bg-[#f6f5e8] hover:bg-[#722F37]/10 transition-colors group"
              >
                <div className="w-12 h-12 bg-[#722F37] flex items-center justify-center">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-[#666666]">Telefon 2</p>
                  <p className="text-lg font-semibold text-[#333333] group-hover:text-[#722F37]">
                    {restaurantInfo.phone2}
                  </p>
                </div>
              </a>

              {/* WhatsApp */}
              <a
                href={`https://wa.me/${restaurantInfo.whatsapp}?text=Merhaba, sipariş vermek istiyorum.`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-6 bg-[#25D366]/10 hover:bg-[#25D366]/20 transition-colors group"
              >
                <div className="w-12 h-12 bg-[#25D366] flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-[#666666]">WhatsApp Sipariş Hattı</p>
                  <p className="text-lg font-semibold text-[#333333] group-hover:text-[#25D366]">
                    {restaurantInfo.whatsappDisplay}
                  </p>
                </div>
              </a>

              {/* Address */}
              <div className="flex items-start gap-4 p-6 bg-[#f6f5e8]">
                <div className="w-12 h-12 bg-[#722F37] flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-[#666666]">Adres</p>
                  <p className="text-base text-[#333333] leading-relaxed">
                    {restaurantInfo.address}
                  </p>
                </div>
              </div>

              {/* Hours */}
              <div className="flex items-center gap-4 p-6 bg-[#f6f5e8]">
                <div className="w-12 h-12 bg-[#722F37] flex items-center justify-center">
                  <Clock className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-[#666666]">Çalışma Saatleri</p>
                  <p className="text-lg font-semibold text-[#333333]">
                    Her Gün {restaurantInfo.hours}
                  </p>
                </div>
              </div>

              {/* Instagram */}
              <a
                href={`https://instagram.com/${restaurantInfo.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-6 bg-[#f6f5e8] hover:bg-[#722F37]/10 transition-colors group"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737] flex items-center justify-center">
                  <Instagram className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-[#666666]">Instagram</p>
                  <p className="text-lg font-semibold text-[#333333] group-hover:text-[#722F37]">
                    @{restaurantInfo.instagram}
                  </p>
                </div>
              </a>
            </div>
          </div>

          {/* Right - Map */}
          <div className="space-y-6">
            <div className="bg-[#f6f5e8] h-[500px] relative">
              <iframe
                src="https://www.google.com/maps?q=Kosovalı+Döner+1990,+Oruçreis,+Giyimkent+16.+Sk.+No:1-21,+34235+Esenler/İstanbul&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Kosovalı Döner Konum"
              />
            </div>
            
            <a
              href="https://maps.app.goo.gl/sDwhztdKZqD2hoVh7"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-[#722F37] text-white text-center py-4 font-semibold hover:bg-[#5A252C] transition-colors"
            >
              Yol Tarifi Al
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;